
import React from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { FormGroup, TextInput, RadioButton, CurrencyInput, InputGroup, DateInput, FormTitleTooltip } from '../../../../../../../../../components/form/form';
import { getYearBasis, getWTPEIRemittanceConvention, getDayCountConvenntion, getPrincipalRepaymentSched } from '../../../../../../../../../helpr/listingFormData';
import { securityInfoObj2, securityInfoValidator2 } from '../../../../../../../../../form-control/listing-form/security-info-control';
import styles from './security-information.module.scss'

const SecurityInformation2 = ({listingInfo, saveListingInfo, nextStep}) => {
  const listingFormState = useValidation(securityInfoValidator2, securityInfoObj2(listingInfo), {border: '1px solid red'});
  const { getRadioButtonProps, getTextFieldProps, getDropdownProps, getField, validate } = listingFormState;

  const nextHandler = (step) => {
    const { isFormValid, formState } = validate();
    saveListingInfo(formState);
    if( step ){ nextStep(step) }
    else if ( isFormValid ){ nextStep(step) }
    else { /*Invalid Form State*/ }
  }

  return (
    <div className={styles['security-information-component']} style={{paddingLeft: '75px', paddingRight : '75px'}}>
      <Row>
        <Col md="4">
          <FormGroup header="YEAR BASIS:*">
            <RadioButton inputProps={getRadioButtonProps('yearBasis')} data={getYearBasis()}/>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <FormTitleTooltip title="WTPEI REMITTANCE CONVENTION:">
              WTPEI refers to Withholding Tax on Previously Earned Interest, as defined
              under the PDEx Guidelines on the Trading and Settlement Environment for
              Long-Term Bank-Issued Instruments (the Guidelines). The Guidelines prescribe
              the market convention for withholding and remittance of the WTPEI for bank-issued
              instruments traded and settled in the PDEx system.
            </FormTitleTooltip>
            <RadioButton inputProps={getRadioButtonProps('wtpeiRemittanceConvention')} data={getWTPEIRemittanceConvention()}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup header="DAY COUNT CONVENTION:*">
            <RadioButton inputProps={getRadioButtonProps('dayCountConvention')} data={getDayCountConvenntion()}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup header="PRINCIPAL REPAYMENT SCHEDULE:*">
            <RadioButton inputProps={getRadioButtonProps('principalRepaymentSched')} data={getPrincipalRepaymentSched()}/>
            { (getField('principalRepaymentSched') === 'AMORTIZED') && <Col md="6">
                <TextInput inputProps={getTextFieldProps('amortizationSched')} placeholder="Amortization Schedule"/>
                <div className={styles['note']}>(please specify amortization schedule or indicate if it is otherwise included or contained in other documents submitted)</div>
              </Col> }
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler(true)} className="btn-secondary">BACK</Button>
        <Button onClick={()=>nextHandler()}>NEXT</Button>
      </Row>
    </div>
  )
}

export default SecurityInformation2;
